import { render } from "./WebmasterFooter.vue?vue&type=template&id=7035f504"
import script from "./WebmasterFooter.vue?vue&type=script&lang=js"
export * from "./WebmasterFooter.vue?vue&type=script&lang=js"

import "./WebmasterFooter.vue?vue&type=style&index=0&id=7035f504&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__